import axiosInstance from './axiosInstance';
import { endpoints } from './endPoints';

/**
 * Uploads a tenant registry logo; returns stored API path (e.g. /api/v1/files/image/tenant-….png).
 * @param {File} file
 * @param {string|null|undefined} registryTenantId — central tenant row UUID when editing (stable filename)
 */
export async function uploadTenantRegistryLogo(file, registryTenantId) {
  if (!file) {
    throw new Error('No file selected');
  }
  if (!file.type.startsWith('image/')) {
    throw new Error('Please select a valid image file');
  }
  if (file.size > 5 * 1024 * 1024) {
    throw new Error('File size must be less than 5MB');
  }
  const formData = new FormData();
  formData.append('file', file);
  const tid =
    registryTenantId != null && String(registryTenantId).trim() !== ''
      ? String(registryTenantId).trim()
      : '';
  const q = tid ? `?tenantId=${encodeURIComponent(tid)}` : '';
  const headers = tid ? { 'X-TenantID': tid } : {};
  const response = await axiosInstance.put(
    `${endpoints.files.tenantLogo}${q}`,
    formData,
    { timeout: 30000, headers }
  );
  const path =
    typeof response.data === 'string' ? response.data : response.data?.data;
  return path != null && String(path).trim() !== '' ? String(path).trim() : '';
}
